import { Link } from 'react-router-dom';

const quickLinks = [
  { label: '首页', to: '/' },
  { label: '资讯', to: '/category/news' },
  { label: '娱乐', to: '/category/entertainment' },
  { label: '科技', to: '/category/tech' },
  { label: '生活服务', to: '/category/life' },
  { label: '专题合集', to: '/special' },
  { label: '关于我们', to: '/about' },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-900 text-background-100 mt-16">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-white flex items-center justify-center font-heading font-bold text-base">
                17
              </span>
              <span className="font-heading font-bold text-lg text-background-50">
                WWW.17C.COM
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-200/80 max-w-sm">
              WWW.17C.COM 是专注多元内容的综合门户平台，聚合资讯、娱乐、科技与生活服务信息，为你提供便捷的一站式访问体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm tracking-wide">
              快速导航
            </h4>
            <ul className="grid grid-cols-2 gap-y-3 gap-x-4">
              {quickLinks.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-background-200/80 hover:text-accent-300 transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm tracking-wide">
              联系我们
            </h4>
            <ul className="space-y-3 text-sm text-background-200/80">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line" />
                <a href="mailto:contact@17c.com" className="hover:text-accent-300 transition-colors">
                  contact@17c.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-weibo-line" />
                <span>微博：@17C综合门户</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line" />
                <span>微信公众号：17C资讯</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-200/60">
          <p>© 2026 WWW.17C.COM 版权所有 | 本站内容为演示数据，仅供展示用途</p>
          <p>互联网信息服务演示平台 · 内容仅供参考</p>
        </div>
      </div>
    </footer>
  );
}